$(function() {
  var breakPoint = 768
  var mainMenu = $('ul.main-nav__menu');

  var mobilebtn = $('.main-nav__menu--mobilebtn');
  var expandButtons = mainMenu.find('.main-nav__menu--expandbtn')

  var firstLevelSelector = '.main-nav__first-level-entry'

  var secondLevelActiveClass = 'main-nav__second-level--active'
  var mainMenuActiveClass = 'main-nav__menu--active'
  var mobileBtnActiveClass = 'main-nav__menu--mobilebtn-close'

  // TRIGGER ACTIVE STATE
  $(mobilebtn).on('click', function() {
    toggleMobileMenu();
  });

  // TRIGGER DROP DOWN SUBS
  expandButtons.on('click', function(event, foo) {
    var isActive = $(this).parent('li').hasClass(secondLevelActiveClass)

    removeActiveSecondLevel();

    if(!isActive) {
      removeActiveSecondLevel();
      $(this).parent('li').addClass(secondLevelActiveClass);
      window.scrollTo(0, $(this).offset().top - 0)
    }
  });

  function toggleMobileMenu() {
    $(mainMenu).toggleClass(mainMenuActiveClass);
    $(mobilebtn).toggleClass(mobileBtnActiveClass);
    removeActiveSecondLevel();
  }

  function removeActiveSecondLevel() {
    $(firstLevelSelector).removeClass(secondLevelActiveClass);
  }

  // check window resize and set everything to inactive if coming from mobile
  $(window).resize(function(event) {
    // remove mobile menu classes
    if ($(window).width() > breakPoint && $('.' + mainMenuActiveClass).length > 0) {
      toggleMobileMenu();
      removeActiveSecondLevel();
    }
  });
});
